import { render, staticRenderFns } from "./EligList.vue?vue&type=template&id=e072ecb2"
import script from "./EligList.vue?vue&type=script&lang=js"
export * from "./EligList.vue?vue&type=script&lang=js"
import style0 from "./EligList.vue?vue&type=style&index=0&id=e072ecb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports